import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserPickupShopsService } from '@checkout-v2/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { DeviceService } from '@shared/services';
import { Pos } from '@shop/const';
import { ShopListService } from '@shop/feature';
import { ModalService } from '@spartacus/storefront';
import { filter, map, take, withLatestFrom } from 'rxjs/operators';
import { SdvorPickupMapSelectPosComponent } from '../pickup-map-select-pos/pickup-map-select-pos.component';
import { SdvorPickupUserShopListModalComponent } from '../pickup-user-shop-list-modal/pickup-user-shop-list-modal.component';

@Component({
  selector: 'sd-pickup-change-shop-button',
  templateUrl: './pickup-change-shop-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      cx-icon {
        width: 26px;
        height: 26px;
      }
    `,
  ],
  standalone: false,
})
export class SdvorPickupChangeShopButtonComponent {
  iconTypes = CUSTOM_ICON_TYPE;

  constructor(
    private modalService: ModalService,
    private userPickupShopsService: UserPickupShopsService,
    private shopListService: ShopListService,
    public deviceService: DeviceService,
  ) {}

  openModal(): void {
    this.userPickupShopsService.listLoading$
      .pipe(
        filter((isLoading) => !isLoading),
        withLatestFrom(this.shopListService.shops$, this.userPickupShopsService.list$),
        map(([, pickupShops, userShops]) =>
          userShops
            ?.map((userShop) => pickupShops?.find((pickupShop) => userShop.name === pickupShop.name))
            .filter(Boolean),
        ),
        map((shops: Pos[] | undefined) => !!shops && !!shops.length),
        take(1),
      )
      .subscribe((hasShops) => {
        if (hasShops) {
          this.modalService.open(SdvorPickupUserShopListModalComponent, {
            centered: true,
            size: 'lg',
          });
        } else {
          this.modalService.open(SdvorPickupMapSelectPosComponent, {
            size: 'xl',
            modalDialogClass: 'modal-rounded',
          });
        }
      });
  }
}
